import { PredefinedAppointmentGroup } from "./PredefinedAppointmentGroup";

class PredefinedAppointmentDay {
    public ControlDate: Date;
    public BlueRectanlge: PredefinedAppointmentGroup[] = [];
}

export { PredefinedAppointmentDay };
